import { BrowserRouter, HashRouter } from 'react-router-dom';
import isPropValid from '@emotion/is-prop-valid';
import styled, { StyleSheetManager } from 'styled-components';
import { createBrowserHistory, createHashHistory } from 'history';

import { FLOATING_BUTTON_HEIGHT } from './utils/common.utils';
import Routes from './Routes';

const shouldForwardProp = (propName, target) => {
  return typeof target === 'string' ? isPropValid(propName) : true;
};

const history = window.cordova ? createHashHistory() : createBrowserHistory();
const Router = window.cordova ? HashRouter : BrowserRouter;

const Root = () => {
  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <div style={{ position: 'relative', height: '100%' }}>
        {/* Portal for floating buttons */}
        <FloatingButtonContainerContainer>
          <FloatingButtonContainer id="floating-button" />
        </FloatingButtonContainerContainer>

        <Router history={history}>
          <Routes />
        </Router>
      </div>
    </StyleSheetManager>
  );
};

const FloatingButtonContainerContainer = styled.div`
  position: absolute;
  display: flex;
  align-items: flex-end;
  top: 0;
  right: 20px;
  height: max(100%, 100vh);
  padding-bottom: 100px;
`;

const gap = 10;

const getNthChildTransform = n =>
  `& > .collapsed:nth-child(${n}) {
    transform: translate(0, ${(n - 1) * (FLOATING_BUTTON_HEIGHT + gap)}px);
    z-index: 1;
    opacity: 0;
  }`;

const FloatingButtonContainer = styled.div`
  position: sticky;
  bottom: 20px;
  right: 20px;
  z-index: 2;
  user-select: none;

  display: flex;
  flex-direction: column-reverse;
  transition: all 2s ease-in-out;

  & > *:not(:first-child) {
    margin-bottom: ${gap}px;
  }

  // Calculate collapse distances for up to 6 children
  ${[2, 3, 4, 5, 6, 7].map(n => getNthChildTransform(n))}
`;

export default Root;
